import Button from "../shared/Button";

export default function ActionFooter({

    onClose,

    onDelete

}){

    return(

        <div className="crm-action-footer">

            <Button

                variant="secondary"

                onClick={onClose}

            >

                Close

            </Button>

            {

                onDelete &&

                <Button

                    variant="danger"

                    onClick={onDelete}

                >

                    Delete Lead

                </Button>

            }
<style>{`.crm-action-footer{

    display:flex;

    justify-content:flex-end;

    gap:12px;

    margin-top:20px;

    padding-top:20px;

    border-top:1px solid #ececec;

}`}</style>
        </div>

    );

}